<div class="cat-perf-card" [ngClass]="scoreClass(cardBand)">
  <h3 class="cat-perf-card__title mds-text--medium-bold">Category Performance</h3>

  @if (isLoading) {
    <div class="cat-perf-card__loading">
      <mc-loading-indicator label="Loading" hiddenlabel variant="ring" fit="small"></mc-loading-indicator>
    </div>
  }

  @if (!isLoading) {
    <div class="cat-perf-card__list">
      @for (row of rows; track row.id) {
        <!-- Category row -->
        <div class="cat-perf-card__cat">
          <button type="button" class="cat-perf-card__cat-header" (click)="toggle(row.id)">
            <mc-icon
              [attr.icon]="row.expanded ? 'chevron-up' : 'chevron-down'"
              size="16"
              class="cat-perf-card__chevron">
            </mc-icon>
            <span class="cat-perf-card__cat-name mds-text--small-bold">{{ row.name }}</span>
            <span class="cat-perf-card__cat-score mds-text--small-bold" [ngClass]="textClass(row.band)">
              {{ row.score }}/{{ row.maxScore }}
            </span>
          </button>

          <!-- Full-width category progress bar -->
          <div class="cat-perf-card__cat-bar">
            <div class="cat-perf-card__cat-bar-fill" [ngClass]="fillClass(row.band)" [style.width.%]="row.progressPct"></div>
          </div>

          <!-- KPI rows (expanded) -->
          @if (row.expanded) {
            <div class="cat-perf-card__kpis">
              @for (kpi of row.kpis; track kpi.name) {
                <div class="cat-perf-card__kpi-row">
                  <span class="cat-perf-card__kpi-name mds-text--x-small-normal mds-neutral__text-color">{{ kpi.name }}</span>
                  <div class="cat-perf-card__kpi-bar-track">
                    <div class="cat-perf-card__kpi-bar-fill" [ngClass]="fillClass(kpi.band)" [style.width.%]="kpi.progressPct"></div>
                  </div>
                  <span class="cat-perf-card__kpi-score mds-text--x-small-normal" [ngClass]="textClass(kpi.band)">
                    {{ kpi.score !== null ? kpi.score + '/' + kpi.maxScore : '—' }}
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
